var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#2070B8",
    fillOpacity: 0.24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.54 16.42C32.4212 15.9454 32.1792 15.5106 31.8386 15.1594C31.498 14.8082 31.0707 14.5532 30.6 14.42C28.88 14 22 14 22 14C22 14 15.12 14 13.4 14.46C12.9292 14.5932 12.5019 14.8482 12.1613 15.1994C11.8207 15.5506 11.5787 15.9854 11.46 16.46C11.1452 18.2056 10.9912 19.9763 11 21.75C10.9887 23.537 11.1427 25.3213 11.46 27.08C11.5909 27.5398 11.8383 27.9581 12.1781 28.2945C12.5179 28.6308 12.9388 28.8738 13.4 29C15.12 29.46 22 29.46 22 29.46C22 29.46 28.88 29.46 30.6 29C31.0707 28.8668 31.498 28.6118 31.8386 28.2606C32.1792 27.9094 32.4212 27.4746 32.54 27C32.8523 25.2676 33.0063 23.5103 33 21.75C33.0112 19.963 32.8572 18.1787 32.54 16.42Z",
    stroke: "#2070B8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.75 25.02L25.5 21.75L19.75 18.48V25.02Z",
    stroke: "#2070B8",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1386b4aafb9b64bd4d922f618d9ddafc.svg";
export { ForwardRef as ReactComponent };